import { defineMessages } from "react-intl";

const PREFIX = "BulkExport.DataSourceControl";
export default defineMessages({
  new: {
    id: `${PREFIX}.new`,
    defaultMessage: "NEW",
  },
  saved: {
    id: `${PREFIX}.saved`,
    defaultMessage: "SAVED",
  },
  noSaved: {
    id: `${PREFIX}.noSaved`,
    defaultMessage: "No saved entries",
  }
});
